














































import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';
import excel from 'exceljs';
import { AxiosError } from 'axios';
import { mapState } from 'vuex';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import { MerchantsMResponse, MerchantsManagement, User } from '@/libs/api.interfaces';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

interface ReportParams {
  channel: { title: string; code: string; path: string };
  channelIds: string[];
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    ActionPopup,
  },
  methods: {
    format,
  },
  computed: mapState(['user']),
})
export default class OnepayMerchantTable extends Vue {
  user!: {
    user: User;
  };

  channel = { title: '', code: '', path: '' };

  loading = true;
  merchants: MerchantsManagement[] = [];

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;
  recurring = '';
  fds = '';
  internal = 0;
  type = '';
  startTitle = '';
  endTitle = '';

  parameter: any = {};
  listOnepayMerchant: any[] = [];

  statuses: { [key: string]: string } = {
    Success: 'Approved',
    Declined: 'Declined',
    'Filtered / Scrubbed': 'Filtered',
    'Processing Error / Internal Application Error': 'Error',
    'Cancelled (Query)': 'Cancelled',
    Pending: 'Pending',
    'Un-Processed': 'Un-Processed',
  }

  format!: (val: number) => string;

  // eslint-disable-next-line class-methods-use-this
  openDetail(itemData: any) {
    this.$router.push(`/onepay/edit/${this.parameter.user_role}/${this.parameter.user_group}/${itemData.merch_id}`);
  }

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
    // console.log('testpage', this.page);
  }

  async getTransaction(params: ReportParams, isExport = false, page = 1) {
    this.channel = params.channel;

    try {
      if (!isExport) {
        this.loading = true;
      }

      const { data } = await api.get<MerchantsMResponse>('/merchants', {
        params: {
          page,
          export: isExport ? true : undefined,
        },
      });
      if (isExport) {
        return data;
      }

      this.page = page;
      this.merchants = data.data;
      this.totalPage = Math.ceil(data.total / data.per_page);
      this.from = data.from;
      this.to = data.to;
      this.totalItem = data.total;
      this.loading = false;

      return null;
    } catch (err) {
      console.error(err);
      return err as AxiosError;
    }
  }

  mounted() {
    this.internal = JSON.parse(localStorage.getItem('USER') || '{}').user.is_internal;
  }

  async export(params: ReportParams) {
    showToast(ToastType.SUCCESS, 'Export Transaction', 'Export is starting, please wait! This may take a while');

    try {
      const workbook = this.createWorkbook();
      // await this.processExportPage(params, workbook, 1);
    } catch (err) {
      console.log(err);
      showToast(ToastType.FAILED, `Error [${(err as AxiosError).response?.status}]`, 'Failed to export transaction');
    }

    showToast(ToastType.SUCCESS, 'Export Transaction', 'Export finished');
  }

  async getListData(params: any, page = 1) {
    try {
      this.loading = true;
      console.log('aaaaaaaaaaa', params);
      this.parameter = params;
      this.parameter.page = page;
      Object.keys(params).forEach((key) => {
        if ((params[key] || params[key] === '0') && params[key] !== 'Invalid Date') {
          this.parameter[key] = params[key];
        }
      });
      console.log('bbbbbbbbbbbbbb', this.parameter);
      const { data } = await api.get('/onepay/merchants', {
        params: this.parameter,
      });

      console.log('data3', data.data.data);
      console.log('data2', data.data);
      console.log('data1', data);
      this.page = page;
      this.listOnepayMerchant = data.data.data;
      this.totalPage = data.last_page;
      this.from = data.from;
      this.to = data.to;
      this.totalItem = data.total;
      this.loading = false;

      return null;
    } catch (err) {
      return err as AxiosError;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  createWorkbook() {
    const workbook = new excel.Workbook();
    const sheet = workbook.addWorksheet('Report', { views: [{ state: 'frozen', ySplit: 1 }] });
    workbook.created = dayjs().toDate();
    sheet.getRow(1).font = { bold: true };

    const columns = [
      { header: 'Transaction Date', width: 18 },
      { header: 'Merchant Name', width: 40 },
      { header: 'Transaction Number', width: 18 },
    ];

    if (this.user.user.is_internal === 1) {
      columns.push({ header: 'Recurring', width: 10 });
      columns.push({ header: 'FDS', width: 10 });
    }

    sheet.columns = columns;

    return workbook;
  }

  // eslint-disable-next-line class-methods-use-this
  async downloadSheet(workbook: excel.Workbook, part?: number) {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer]);

    const fileURL = window.URL.createObjectURL(blob);
    const fileLink = document.createElement('a');
    const day = dayjs().get('date');
    const month = dayjs().get('month') + 1;
    const year = dayjs().get('year');

    // eslint-disable-next-line max-len
    const filename = this.startTitle ? `${this.startTitle}-${this.endTitle} - report - ${this.channel.path}${part ? `.part${part}` : ''}.xlsx` : `${day}${month}${year} - report - ${this.channel.path}${part ? `.part${part}` : ''}.xlsx`;
    fileLink.setAttribute('download', filename);

    fileLink.href = fileURL;
    document.body.appendChild(fileLink);
    fileLink.click();
  }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }
}
